// Mobile, tablet or desktop, this is the question ...
$.fn.detectAgent = function(){

    var MobileDetect = require('mobile-detect'),
        md = new MobileDetect(window.navigator.userAgent);

    //console.log( "md.mobile", md.mobile() ); // null if not mobile device
    //console.log( "md.phone", md.phone() ); // null if not smartphone
    //console.log( "md.tablet", md.tablet() ); // null if not tablet
    //console.log( "md.userAgent", md.userAgent() ); // Browser used. Chrome, Firefox, Dolfin, etc...
    //console.log( "md.os", md.os() ); // Android, iOS, Windwows, OSX, or Linux
    //console.log( "md.version", md.version('Webkit') ); // Webkit version
    //console.log( "md.versionStr", md.versionStr('Build') ); // Build

    if( md.tablet() )
        return 'tablet';

    if( md.phone() )
        return 'mobile';

    return 'desktop';

};

$.fn.readDeviceOrientation = function() {

    if (Math.abs(window.orientation) === 90) {
        // Landscape
        return "LANDSCAPE";
    } else {
        // Portrait
        return "PORTRAIT";
    }
};

$.fn.rotateYourTablet = function(){

    var orientation = $.fn.readDeviceOrientation(),
        agent = $.fn.detectAgent();

    switch (agent) {

        case "tablet":

            if( orientation == "LANDSCAPE" ){
                $('#rotate-your-tablet').show();
                //alert('SHOW -> '+ agent +" - "+ orientation);
            }else{
                $('#rotate-your-tablet').hide();
                //alert('HIDE -> '+ agent +" - "+ orientation);
            }

            break;

        case "mobile":

            if( orientation == "LANDSCAPE" ){
                $('#rotate-your-tablet').show();
                //alert('SHOW -> '+ agent +" - "+ orientation);
            }else{
                $('#rotate-your-tablet').hide();
                //alert('HIDE -> '+ agent +" - "+ orientation);
            }

            break;
    }

};

$(function(){
    $(window)
        .on('orientationchange', function(event) {
            $.fn.rotateYourTablet();
        });
    $.fn.rotateYourTablet();
});
